﻿(function () {
  const root = document.getElementById("sora-newsletter-popup");
  if (!root) return;

  const storageKey = root.dataset.storageKey || "sora_nl_popup_v1";
  const dismissKey = storageKey + "_session_dismiss";
  const delayMs = Number(root.dataset.delayMs || 10000);
  const reshowMs = Number(root.dataset.reshowMs || 75000);
  const autoCloseMs = Number(root.dataset.autoCloseMs || 75000);
  const dialog = root.querySelector(".sora-popup__dialog");
  const openClass = "is-open";
  const scrollLockClass = "sora-scroll-lock";
  const pageLoadAt = Date.now();
  let opened = false;
  let delayTimer = null;
  let reshowTimer = null;
  let autoCloseTimer = null;
  let scrollBound = false;

  function readSubscribed() {
    try {
      const state = JSON.parse(localStorage.getItem(storageKey) || "null");
      return state && state.subscribed === true;
    } catch (_) {
      return false;
    }
  }

  function writeSubscribed() {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ subscribed: true, at: Date.now() }));
    } catch (_) {
      /* ignore quota / private mode */
    }
  }

  function getDismissedAt() {
    try {
      const raw = sessionStorage.getItem(dismissKey);
      if (!raw) return null;
      if (raw === "1") return pageLoadAt;
      const ts = Number(raw);
      return Number.isFinite(ts) ? ts : null;
    } catch (_) {
      return null;
    }
  }

  function dismissedRecently() {
    const at = getDismissedAt();
    if (!at) return false;
    return Date.now() - at < reshowMs;
  }

  function markDismissedSession() {
    try {
      sessionStorage.setItem(dismissKey, String(Date.now()));
    } catch (_) {
      /* ignore */
    }
  }

  function elapsedReady() {
    return Date.now() - pageLoadAt >= delayMs;
  }

  function shouldShow() {
    if (root.dataset.force === "true") return true;
    if (root.dataset.suppress === "true") return false;
    if (readSubscribed()) return false;
    if (dismissedRecently()) return false;
    return true;
  }

  function privacyBannerOpen() {
    // Live Shopify PC banner is a SECTION#shopify-pc__banner (not a <dialog open>).
    // Never show signup under it -- cookie z-index is ~2e6 and covers the CTA.
    // Also wait while Manage preferences (#shopify-pc__prefs) is open.
    if (document.querySelector("#shopify-pc__prefs__overlay")) return true;
    const prefs = document.querySelector("#shopify-pc__prefs, .shopify-pc__prefs");
    if (prefs && !prefs.hidden) {
      const prefsStyle = window.getComputedStyle(prefs);
      if (
        prefsStyle.display !== "none" &&
        prefsStyle.visibility !== "hidden" &&
        Number(prefsStyle.opacity) !== 0
      ) {
        const prefsRect = prefs.getBoundingClientRect();
        if (prefsRect.width > 8 && prefsRect.height > 8) return true;
      }
    }
    const selectors = [
      "#shopify-pc__banner",
      ".shopify-pc__banner__dialog",
      ".shopify-privacy-banner",
      "[data-shopify-privacy-banner]",
    ];
    for (let i = 0; i < selectors.length; i += 1) {
      const banner = document.querySelector(selectors[i]);
      if (!banner || banner.hidden) continue;
      const style = window.getComputedStyle(banner);
      if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) {
        continue;
      }
      const rect = banner.getBoundingClientRect();
      if (rect.width > 8 && rect.height > 8) return true;
    }
    return false;
  }

  function lockScroll() {
    document.documentElement.classList.add(scrollLockClass);
    document.documentElement.style.overflow = "hidden";
  }

  function unlockScroll() {
    document.documentElement.classList.remove(scrollLockClass);
    document.documentElement.style.overflow = "";
    if (document.body && document.body.style.overflow === "hidden") {
      document.body.style.overflow = "";
    }
  }

  function notifyClosed() {
    root.dispatchEvent(new CustomEvent("sora:popup-closed", { bubbles: true }));
  }

  function clearAutoCloseTimer() {
    if (autoCloseTimer) {
      window.clearTimeout(autoCloseTimer);
      autoCloseTimer = null;
    }
  }

  function scheduleAutoClose() {
    clearAutoCloseTimer();
    if (!Number.isFinite(autoCloseMs) || autoCloseMs <= 0) return;
    autoCloseTimer = window.setTimeout(function () {
      if (root.classList.contains(openClass)) {
        closePopup("dismiss");
      }
    }, autoCloseMs);
  }

  function scheduleReshow() {
    if (reshowTimer) {
      window.clearTimeout(reshowTimer);
      reshowTimer = null;
    }
    if (readSubscribed()) return;
    const at = getDismissedAt();
    if (!at) return;
    const wait = Math.max(0, reshowMs - (Date.now() - at));
    reshowTimer = window.setTimeout(function () {
      reshowTimer = null;
      if (!shouldShow()) return;
      if (!elapsedReady()) return;
      tryOpenWhenReady();
    }, wait);
  }

  function openPopup() {
    if (opened || root.classList.contains(openClass)) return;
    if (!shouldShow() && root.dataset.justPosted !== "true") return;
    opened = true;
    if (delayTimer) {
      window.clearTimeout(delayTimer);
      delayTimer = null;
    }
    root.classList.add(openClass);
    root.setAttribute("aria-hidden", "false");
    lockScroll();
    scheduleAutoClose();
    const closeBtn = root.querySelector(".sora-popup__close");
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function tryOpenWhenReady() {
    if (opened) return;
    if (!elapsedReady()) return;
    if (!shouldShow() && root.dataset.justPosted !== "true") return;
    if (privacyBannerOpen()) {
      window.setTimeout(tryOpenWhenReady, 800);
      return;
    }
    openPopup();
  }

  function closePopup(reason) {
    clearAutoCloseTimer();
    root.classList.remove(openClass);
    root.setAttribute("aria-hidden", "true");
    unlockScroll();
    opened = false;
    if (reason === "subscribed") {
      writeSubscribed();
    } else {
      markDismissedSession();
      scheduleReshow();
    }
    notifyClosed();
  }

  root.querySelectorAll("[data-sora-popup-close]").forEach(function (el) {
    el.addEventListener("click", function () {
      closePopup("dismiss");
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && root.classList.contains(openClass)) {
      closePopup("dismiss");
    }
  });

  window.addEventListener("pagehide", unlockScroll);

  function bindScrollOpen() {
    if (scrollBound || !shouldShow()) return;
    scrollBound = true;
    const threshold = Math.min(window.innerHeight * 0.45, 520);

    function onScroll() {
      if (opened || !shouldShow() || !elapsedReady()) return;
      if (window.scrollY >= threshold) {
        window.removeEventListener("scroll", onScroll);
        tryOpenWhenReady();
      }
    }

    if (window.scrollY >= threshold && elapsedReady()) {
      window.setTimeout(tryOpenWhenReady, 300);
      return;
    }

    window.addEventListener("scroll", onScroll, { passive: true });
  }

  if (root.dataset.justPosted === "true") {
    root.classList.add("is-success");
    writeSubscribed();
    openPopup();
    return;
  }

  if (!shouldShow()) {
    if (getDismissedAt() && !readSubscribed()) scheduleReshow();
    return;
  }

  delayTimer = window.setTimeout(function () {
    tryOpenWhenReady();
  }, Number.isFinite(delayMs) ? delayMs : 10000);

  bindScrollOpen();

  document.addEventListener(
    "mouseout",
    function (event) {
      if (opened || !shouldShow() || !elapsedReady()) return;
      if (event.relatedTarget || event.toElement) return;
      if (event.clientY > 12) return;
      tryOpenWhenReady();
    },
    { passive: true }
  );

  if (dialog) {
    dialog.addEventListener("click", function (event) {
      event.stopPropagation();
    });
  }
})();
